<template>
  <div v-show="visible" class="popup v-fade" @click="hide">
    <div class="container popup__flex-box">
      <div class="popup__content" @click="$event.stopPropagation()">
        <div class="popup__close">
          <a @click="hide"
            ><span class="popup__close-icon iconfont iclose"></span
          ></a>
        </div>
        <div class="popup__title-box">
          <h2 class="popup__title">Edit your credit card</h2>
          <p class="popup__text">
            If you want to update your credit card used for your subscription,
            please do it below.
          </p>
        </div>
        <div>
          <form class="payment-form" @submit="submitForm">
            <StripeCard
              v-if="visible && billing.cardEditMode"
              ref="stripeCard"
              :billing="billing"
              :show-button="false"
            />
            <StripeCardInfo v-else ref="stripeCardInfo" :billing="billing" />
            <button
              v-wait:disabled="'Saving'"
              type="submit"
              class="payment-form__btn btns btns--largest btns--font-large btns--full"
            >
              <v-wait for="Saving">
                <template v-slot:waiting>
                  Saving
                  <button-spinner />
                </template>
                <span>Save</span>
              </v-wait>
            </button>
            <FormError :errors="validation.errors" :field="billing.plan.id" />
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useWait } from '@/app/composables/useWait'

import { BillingView } from '@/models/billing'
import { ValidationState } from '@/helpers/form'

import FormError from '@/components/ui/FormError.vue'
import ButtonSpinner from '@/components/ui/ButtonSpinner.vue'
import StripeCard from '@/app/components/billing/StripeCard.vue'
import StripeCardInfo from '@/app/components/billing/StripeCardInfo.vue'

const props = defineProps<{
  billing: BillingView
}>()

const wait = useWait()

const stripeCard = ref<InstanceType<typeof StripeCard> | null>(null)

const validation = ref(new ValidationState())
const visible = ref(false)

function show(): void {
  props.billing.cardEditMode = true
  visible.value = true
}

function hide(): void {
  props.billing.cardEditMode = false
  visible.value = false
}

async function submitForm(event: Event): Promise<void> {
  event.preventDefault()
  await subscribe()
}

async function subscribe(): Promise<void> {
  try {
    wait.start('Saving')
    let hideDialog: boolean = true
    if (props.billing.cardEditMode && stripeCard.value?.needsSaving()) {
      const result = await stripeCard.value?.save()
      if (result !== true) {
        hideDialog = false
      }
    }
    if (hideDialog) {
      hide()
    }
    wait.end('Saving')
  } catch (error) {
    wait.end('Saving')
    validation.value.showErrors(error)
  }
}

defineExpose({
  show,
  hide,
})
</script>
